import { useTheme as muiUseTheme } from '@mui/material/styles'

const useTheme = () => muiUseTheme()

export default useTheme
